enum PricingPlanFeature {
	LIMIT_REVIEWERS_PAST_COMMENTS_ACCESS = 'limit_reviewers_past_comments_access',
	WORKSPACE_CUSTOM_BRANDING = 'custom_branding',
	ASSIGN_USERS_TO_ASSETS = 'assign_users_to_assets',
	LABEL_GROUPS = 'label_groups',
	CONTACT_GROUPS = 'contact_groups'
}

export default PricingPlanFeature;
